const login_internal = () => import(/* webpackPrefetch: true */ '@/views/public/internal/index.vue')

const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')

const routes = [
  {
    path: "/internal/login",
    name: "Admin Internal Login",
    component: login_internal,
    meta: {
      title: "Admin Internal Login"
    }
  },

  {
    path: "/login",
    name: "Admin Login",
    component: login,
    meta: {
      title: "Admin Login"
    }
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})